import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { DataTable } from 'components';
import clsx from 'clsx';
import moment from 'moment';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Paper } from '@mui/material';

const useStyles = makeStyles((theme) => ({
	root: {}
}));

const CommentsHistoryTable = (props) => {
	const { data, ...rest } = props;
	const classes = useStyles();
	const rows = data || [];

	return (
		<div {...rest}>
			<TableContainer component={Paper}>
				<Table size="small" aria-label="a dense table">
					<TableBody>
						{rows.map((row) => (
							<TableRow
								key={row.name}
								sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
							>
								<TableCell sx={{ width: 150 }} align="left">{row.user}</TableCell>
								<TableCell sx={{ width: 150 }} align="left">{moment(row.date).format('YYYY-MM-DD HH:mm')}</TableCell>
								<TableCell align="left">{row.comment}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
};

CommentsHistoryTable.propTypes = {
	data: PropTypes.array.isRequired,
};

export default CommentsHistoryTable;
